import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/productosCargaMasiva";

export interface ProductosCargaMasivaDispatcher {
  validarProductosCargaMasiva: (formData: FormData) => Promise<Preview<any>>;
  procesarProductosCargaMasiva: (formData: FormData) => Promise<Preview<any>>;
}

export const productosCargaMasivaDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ProductosCargaMasivaDispatcher = dispatch => ({
  validarProductosCargaMasiva: (formData: FormData) => {
    return dispatch(actions.validarProductosCargaMasiva(formData));
  },
  procesarProductosCargaMasiva: (formData: FormData) => {
    return dispatch(actions.procesarProductosCargaMasiva(formData));
  }
});
